import { loadFromStorage } from "./storage";

export type TaxFilters = {
  material: string;
  description: string;
  emitter: string;
  centers: string[];
  statuses: string[];
  flags: string[];
  harmon: string[];
  startDate: string;
  endDate: string;
  classificationQuizStartDate: string;
  classificationQuizFinishDate: string;
  classificationApprovalStartDate: string;
  classificationApprovalEndDate: string;
};

export const getTaxFiltersFromStorage = (): TaxFilters => ({
  material: loadFromStorage<string>("materialPartNumber", ""),
  description: loadFromStorage<string>("materialPartDesc", ""),
  emitter: loadFromStorage<string>("emitentePartNumber", ""),
  centers: loadFromStorage<{ value: string }[]>("selectedCenter", []).map(
    (item) => item.value,
  ),
  statuses: loadFromStorage<{ status: string }[]>("selectedStatus", []).map(
    (item) => item.status,
  ),
  flags: loadFromStorage<{ flag: string }[]>("selectedFlag", []).map(
    (item) => item.flag,
  ),
  harmon: loadFromStorage<{ value: string }[]>("selectedHarmon", []).map(
    (item) => item.value,
  ),
  startDate: loadFromStorage<string>("startDate", ""),
  endDate: loadFromStorage<string>("endDate", ""),
  classificationQuizStartDate: loadFromStorage<string>(
    "classificationQuizStartDate",
    "",
  ),
  classificationQuizFinishDate: loadFromStorage<string>(
    "classificationQuizFinishDate",
    "",
  ),
  classificationApprovalStartDate: loadFromStorage<string>(
    "classificationApprovalStartDate",
    "",
  ),
  classificationApprovalEndDate: loadFromStorage<string>(
    "classificationApprovalEndDate",
    "",
  ),
});

export const hasAnyNonDateFilter = (filters: TaxFilters): boolean =>
  !!filters.material ||
  !!filters.description ||
  !!filters.emitter ||
  filters.centers.length > 0 ||
  filters.statuses.length > 0 ||
  filters.flags.length > 0 ||
  filters.harmon.length > 0;
